
function options(file){
  const DOMAIN = process.env.REACT_APP_API_URL
  const TOKEN = JSON.parse(localStorage.getItem("authUser")).data.token;
  const HEADERS = new Headers();
        HEADERS.append("Authorization",`Bearer ${TOKEN}`);
        if(file ===undefined)
          HEADERS.append("Content-Type",`application/json`);
  return {'domain':DOMAIN,'headers':HEADERS}
}

export async function httpGet(url,navigate) {
  const parameters = options();
  try {
    const response = await fetch(`${parameters.domain}${url}`, {
      method: 'GET',
      headers: parameters.headers,
      redirect: "follow"
    });
    if (response.status === 401) {
      console.log("ERROR ERESPONSES",response.status);
    //   // Handle unauthorized access (e.g., redirect to login page)
      navigate('/login'); // Use navigate instead of history.push
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error MUESTRAS:', error);
    throw error;
  }
}
export async function httpUpload(url, datasend,navigate) {
  const parameters = options(true);
  try {
    const response = await fetch(`${parameters.domain}${url}`, {
      method: 'POST',
      headers: parameters.headers,
      body: datasend,
      redirect: "follow",
    });
    // console.log(response.status);
    if (response.status === 401) {
      navigate('/login');
    }
    if (!response.ok) {
      const errorData = await response.json(); // Attempt to parse JSON error response
      const errorMessage = ` ${response.status}`;
      throw new Error(`${errorMessage}\n${errorData.error || ''}`);
    }
    const responseData = await response.json();
    // console.log(responseData);
    
    return responseData;
  } catch (error) {
    console.error('Error:', error.message);
    throw error;
  }
}

export async function httpPost(url, datasend,navigate) {
  const parameters = options();
  try {
    const response = await fetch(`${parameters.domain}${url}`, {
      method: 'POST',
      headers: parameters.headers,
      body: JSON.stringify(datasend),
      redirect: "follow",
    });
    // console.log(response.status);
    if (response.status === 401) {
      navigate('/login');
    }
    return await response.json();
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}
export async function httpPUT(url, datasend,navigate) {
  const parameters = options();
  // console.log(datasend);
  try {
    const response = await fetch(`${parameters.domain}${url}`, {
      method: 'PUT',
      headers: parameters.headers,
      body: JSON.stringify(datasend),
      redirect: "follow",
    });
    // console.log(response.status);
    if (response.status === 401) {
      navigate('/login');
    }
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function httpDelete(url, datasend, navigate) {
  const parameters = options();
  try {
    const response = await fetch(`${parameters.domain}${url}`, {
      method: 'DELETE',
      headers: parameters.headers,
      body: JSON.stringify(datasend),
      redirect: "follow",
    });
    if (response.status === 401) {
      navigate('/login');
    }
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}